import React from "react";

const Select = ({ options, value, onChange, label }) => {
  return (
    <div className="flex flex-col gap-2">
      {label && <label className="text-[#1E293B] font-medium">{label}</label>}
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full p-2 border border-gray-300 bg-[#F1F4F9] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option value="" >
          Select an option
        </option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
